import React from "react";
const Docs = () =>{
  return(
   <div>
    <h1>Docs page</h1>
   </div>
  );
}
export default Docs;
